import { Control, Controller, FieldErrors } from "react-hook-form";
import AppButton from "../../../../components/ui/AppButton";
import AppInputField from "../../../../components/ui/AppInputField";

interface TripDetailsFormData {
  fromLocation: string;
  toLocation: string;
  approximateDistance: number;
  totalExpectedIncome: number;
  totalIncomeEarned: number;
  totalPassengers: number;
  perPassengerRate: number;
  driverId: string;
  vehicleId: string;
}

interface TripDetailsStepProps {
  control: Control<TripDetailsFormData>;
  errors: FieldErrors<TripDetailsFormData>;
  onNext: () => void;
  onCancel: () => void;
}

const TripDetailsStep = ({
  control,
  errors,
  onNext,
  onCancel,
}: TripDetailsStepProps) => {
  return (
    <div className="p-6 space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <Controller
          control={control}
          name="fromLocation"
          render={({ field }) => (
            <AppInputField
              label="Start Location"
              type="text"
              error={errors.fromLocation?.message}
              {...field}
              className="bg-[#F6F6F6] border-[#F6F6F6] h-[48px]"
              placeholder="Enter start location"
            />
          )}
        />

        <Controller
          control={control}
          name="toLocation"
          render={({ field }) => (
            <AppInputField
              label="End Location"
              type="text"
              error={errors.toLocation?.message}
              {...field}
              className="bg-[#F6F6F6] border-[#F6F6F6] h-[48px]"
              placeholder="Enter end location"
            />
          )}
        />

        <Controller
          control={control}
          name="approximateDistance"
          render={({ field }) => (
            <AppInputField
              label="Expected Distance Covered (km)"
              type="number"
              error={errors.approximateDistance?.message}
              {...field}
              value={field.value || ""}
              onChange={(e) => field.onChange(parseFloat(e.target.value) || 0)}
              className="bg-[#F6F6F6] border-[#F6F6F6] h-[48px]"
              placeholder="Enter expected distance"
            />
          )}
        />
      </div>

      <div className="flex justify-start items-start space-x-4 pt-4">
        <AppButton
          type="button"
          onClick={onCancel}
          className="px-6 py-2 bg-[#F6F6F6] rounded-md text-gray-700 hover:bg-gray-50 transition-colors text-[15px]"
        >
          Cancel
        </AppButton>

        <AppButton
          type="button"
          onClick={onNext}
          className="px-6 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors text-[15px]"
        >
          Continue
        </AppButton>
      </div>
    </div>
  );
};

export default TripDetailsStep;
